import type {
  BlockEvent,
  BlockEventHistory,
  BlockEventHistoryWithUserName,
} from "@sperrdatei/dto/types";

export const isBlockEventHistoryWithUserNameItem = (
  value: BlockEvent | BlockEventHistory | BlockEventHistoryWithUserName,
): value is BlockEventHistoryWithUserName => {
  return "user" in value;
};
